import { styled } from "@mui/material/styles";
import { Container, Grid } from "@mui/material";
import { range } from "ramda";

import Placeholder from "components/Placeholder";

const StyledGrid = styled(Grid)({
  marginBottom: 40,
});

const AlgoliaSearchResultSkeleton = () => {
  return (
    <Container>
      <StyledGrid container spacing={2}>
        {range(0, 15).map((index) => (
          <Grid key={`StarringYouCards-placeholder-${index}`} item xs={6} sm={3} md={3} lg={2.4}>
            <Placeholder variant="rect" ratio="4/6" />
          </Grid>
        ))}
      </StyledGrid>
    </Container>
  );
};

export default AlgoliaSearchResultSkeleton;
